angular.module('SpidApp')

.factory('StampWorkflow', [function () {
    var StampWorkflow = function (reconciliation) {
        if (!reconciliation ||
            !reconciliation.affranchissement ||
            !reconciliation.choixOptionAffranchissementDestination ||
            !reconciliation.complementServiceAffranchissementDestination ||
            !reconciliation.destination ||
            !reconciliation.destinationZone ||
            !reconciliation.optionAffranchissementDestination ||
            !reconciliation.prixServiceAffranchissementDestination ||
            !reconciliation.prixTrancheAffranchissementZone ||
            !reconciliation.restriction ||
            !reconciliation.serviceAffranchissementDestination ||
            !reconciliation.zoneAffranchissement
        ) {
            throw 'StampWorkflow() - Missing parameters'
        }
        
        this.affranchissement                             = reconciliation.affranchissement
        this.choixOptionAffranchissementDestination       = reconciliation.choixOptionAffranchissementDestination
        this.complementServiceAffranchissementDestination = reconciliation.complementServiceAffranchissementDestination
        this.destination                                  = reconciliation.destination
        this.destinationZone                              = reconciliation.destinationZone
        this.optionAffranchissementDestination            = reconciliation.optionAffranchissementDestination
        this.prixServiceAffranchissementDestination       = reconciliation.prixServiceAffranchissementDestination
        this.prixTrancheAffranchissementZone              = reconciliation.prixTrancheAffranchissementZone
        this.restriction                                  = reconciliation.restriction
        this.serviceAffranchissementDestination           = reconciliation.serviceAffranchissementDestination
        this.zoneAffranchissement                         = reconciliation.zoneAffranchissement
        
        this.destinationFilter             = null
        this.affranchissementFilter        = null
        this.poidsFilter                   = null
    }
    
    // Setters part
    StampWorkflow.prototype.filterByDestination = function (filter) {
        if (!filter) {
            throw 'StampWorkflow::filterByDestination() - Missing parameters'
        }
        
        this.destinationFilter             = null
        this.affranchissementFilter        = null
        this.poidsFilter                   = null
        
        this.destinationFilter = filter
    }
    
    StampWorkflow.prototype.filterByAffranchissement = function (filter) {
        if (!filter) {
            throw 'StampWorkflow::filterByAffranchissement() - Missing parameters'
        }
        
        this.affranchissementFilter        = null
        this.poidsFilter                   = null
        
        this.affranchissementFilter = filter
    }
    
    StampWorkflow.prototype.filterByPoids = function (filter) {
        if (filter === undefined || filter === null) {
            throw 'StampWorkflow::filterByPoids() - Missing parameters'
        }
        
        if (filter === 0) {
            throw 'StampWorkflow::filterByPoids() - Filter cannot be 0'
        }

        this.poidsFilter = filter
    }
    
    // Getters part
    StampWorkflow.prototype.getDestination = function () {
        return this.destination
    }
    
    StampWorkflow.prototype.getAffranchissement = function () {
        if (!this.destinationFilter) {
            throw 'StampWorkflow::getAffranchissement() - Filters not set. You\'re not respecting the workflow'
        }
        
        var codeDestination = this.destinationFilter
        
        var destinationZones = _.filter(this.destinationZone, function (e) {
            return codeDestination == e.code_destination
        })

        var zoneAffranchissements = _.filter(this.zoneAffranchissement, function (e) {
            return !!_.find(destinationZones, function (ee) {
                return e.id_zone == ee.id_zone
            })
        })
        
        var affranchissements = _.chain(this.affranchissement).filter(function (a) {
            return !!_.find(zoneAffranchissements, function (z) {
                return a.code_affranchissement == z.code_affranchissement
            })
        }).unique(function (a) {
            return a.code_affranchissement
        }).value()
        
        if (this.affranchissementFilter !== undefined && this.affranchissementFilter !== null) {
            var code_affranchissement = this.affranchissementFilter
            affranchissements = _.filter(affranchissements, function (a) {
                return a.code_affranchissement == code_affranchissement
            })
        }

        return affranchissements
    }
    
    StampWorkflow.prototype.getTranche = function () {
        if (!this.destinationFilter || !this.affranchissementFilter || !this.poidsFilter) {
            throw 'StampWorkflow::getTranche() - Filters not set. You\'re not respecting the workflow'
        }
        
        var code_affranchissement = this.affranchissementFilter
        
        var affranchissement = _.find(this.getAffranchissement(), function (a) {
            a.code_affranchissement = code_affranchissement;
            return a.code_affranchissement;
        })
        
        if (!affranchissement) {
            throw 'StampWorkflow::getTranche() - Couldn\'t find a matching "affranchissement"'
        }

        var codeDestination = this.destinationFilter

        var destinationZones = _.filter(this.destinationZone, function (e) {
            return codeDestination == e.code_destination
        })
        
        var poids = this.poidsFilter

        var tranche = _.chain(this.prixTrancheAffranchissementZone).filter(function (t) {
            return +t.tranche_inferieure <= poids && poids <= +t.tranche_superieure && t.code_affranchissement == code_affranchissement
        })
        .filter(function (e) {
            return !!_.find(destinationZones, function (ee) {
                return e.id_zone == ee.id_zone
            })
        })
        .first()
        .value()
        
        if (!tranche) {
            throw 'StampWorkflow::getTranche() - Couldn\'t find a matching "poids"'
        }
        
        return tranche
    }
    
    StampWorkflow.prototype.getPrix = function () {
        return +this.getTranche().prix
    }
    
    StampWorkflow.prototype.getServices = function () {
        if (  !this.destinationFilter || !this.affranchissementFilter) {
            throw 'StampWorkflow::getServices() - Filters not set. You\'re not respecting the workflow'
        }

        var self = this
        
        var code_destination      = this.destinationFilter
        var code_affranchissement = this.affranchissementFilter

        return _.chain(this.prixServiceAffranchissementDestination).filter(function (s) {
            return s.code_destination == code_destination && s.code_affranchissement == code_affranchissement
        
        }).map(function (s) {
            var found = _.find(self.serviceAffranchissementDestination, function (sad) {
                return (
                    sad.code_service          == s.code_service_speciaux &&
                    sad.code_destination      == s.code_destination &&
                    sad.code_affranchissement == s.code_affranchissement
                )
            });

            var NO_SERVICE = '<service inconnu>';
            
            s.lib_long = NO_SERVICE
            s.mandatory = false
            if (found) {
                s.lib_long = found.lib_long || NO_SERVICE
                s.mandatory = ((+found.mandatory) !== 0)
            }
            
            return s
        }).value()
    }
    
    StampWorkflow.prototype.resetFilters = function () {
        this.destinationFilter           = null
        this.affranchissementFilter      = null
        this.poidsFilter                 = null
    }
    
    StampWorkflow.prototype.getFilters = function () {
        return {
              destination      : this.destinationFilter
            , affranchissement : this.affranchissementFilter
            , poids            : this.poidsFilter
        }
    }
    
    StampWorkflow.prototype.getZone = function () {
        if (!this.destinationFilter || !this.affranchissementFilter || !this.poidsFilter) {
            throw 'StampWorkflow::getPrix() - Filters not set. You\'re not respecting the workflow'
        }
        
        var codeDestination = this.destinationFilter
        var code_affranchissement = this.affranchissementFilter
        
        var destinationZones = _.filter(this.destinationZone, function (e) {
            return codeDestination == e.code_destination
        })

        var zoneAffranchissements = _.filter(this.zoneAffranchissement, function (e) {
            return !!_.find(destinationZones, function (ee) {
                return e.id_zone == ee.id_zone && e.code_affranchissement == code_affranchissement
            })
        })

        if (zoneAffranchissements.length > 1) {
            console.error('Multiple zone for destination, using the first one', zoneAffranchissements[0])
        }
        
        if (zoneAffranchissements.length === 0) {
            throw 'StampWorkflow::getZone() - Couln\'t find any zone'
        }
        
        return zoneAffranchissements[0]
    }
    
    StampWorkflow.prototype.getComplementAerien = function () {
        var zone = this.getZone()
        
        var prixComp = zone.prix_complementaire
        var poidsComp = zone.poids_complementaire
        var seuil = zone.seuil
        var poids = this.poidsFilter

        var res = 0.00
        //Si on a des valeurs et que le poids est > au seuil
        if (poids && poidsComp && prixComp && seuil && poids > seuil ) {
            //on calcule dans quelle tranche supérieure on est et on multiplie par le prix complément
            if(poidsComp > 0) {
                var nbComp = Math.ceil(poids / poidsComp)
                res = nbComp * prixComp
            }
            //Si on a pas de poids complément, on peut considérer qu'il y a qu'une tranche
            else {
                res = prixComp
            }
        }
        return res
    }
    
    return StampWorkflow
}])